import { useEffect, useState, useCallback } from 'react';
import api from '../api/axios';

const useVendorOptions = (enabled = true) => {
  const [companyCodes,   setCompanyCodes]   = useState([]);
  const [bpGroupings,    setBpGroupings]    = useState([]);
  const [paymentTerms,   setPaymentTerms]   = useState([]);
  const [purchasingOrgs, setPurchasingOrgs] = useState([]);
  const [incoterms,      setIncoterms]      = useState([]);
  const [planningGroups, setPlanningGroups] = useState([]);
  const [regions,        setRegions]        = useState([]);
  const [bankKeys,            setBankKeys]            = useState([]);
  const [withholdingTaxTypes, setWithholdingTaxTypes] = useState([]);
  const [withholdingTaxCodes, setWithholdingTaxCodes] = useState([]);

  useEffect(() => {
    if (!enabled) return;
    api.get('/sap/options/company-codes').then(r => setCompanyCodes(r.data)).catch(() => {});
    api.get('/sap/options/bp-groupings').then(r => setBpGroupings(r.data)).catch(() => {});
    api.get('/sap/options/payment-terms').then(r => setPaymentTerms(r.data)).catch(() => {});
    api.get('/sap/options/purchasing-orgs').then(r => setPurchasingOrgs(r.data)).catch(() => {});
    api.get('/sap/options/incoterms').then(r => setIncoterms(r.data)).catch(() => {});
    api.get('/sap/options/planning-groups').then(r => setPlanningGroups(r.data)).catch(() => {});
    api.get('/sap/options/regions').then(r => setRegions(r.data)).catch(() => {});
    api.get('/sap/options/bank-keys').then(r => setBankKeys(r.data)).catch(() => {});
    api.get('/sap/options/withholding-tax').then(r => {
      setWithholdingTaxTypes(r.data.types || []);
      setWithholdingTaxCodes(r.data.codes || []);
    }).catch(() => {});
  }, [enabled]);

  const refetchPlanningGroups = useCallback((companyCode) => {
    const params = companyCode ? { companyCode } : {};
    api.get('/sap/options/planning-groups', { params })
      .then(r => setPlanningGroups(r.data)).catch(() => {});
  }, []);

  return { companyCodes, bpGroupings, paymentTerms, purchasingOrgs, incoterms, planningGroups, regions, bankKeys, withholdingTaxTypes, withholdingTaxCodes, refetchPlanningGroups };
};

export default useVendorOptions;
